export enum PaymentMethods {
  bank = "bank",
  card = "card",
  cash = "cash",
}
